import { RouteObject } from "react-router-dom";
import ValidateSsoOld from "./OldSSO/ValidateSsoOld";
import { R_SsoRoutes } from "../../utils/Routes";

const SsoRoutes: RouteObject[] = [
  {
    path: R_SsoRoutes.SsoOld_TokenNo_TokenRefNo,
    element: <ValidateSsoOld />,
  },
];
export default SsoRoutes;
